/*-----------------------------------------------------
	Ratings
-----------------------------------------------------*/

function renderSnippet(e, t, i, n) {
    var r = "";
    for (s = 1; s <= Math.ceil(e); s++) r += '<i class="ruk-icon-full-star-01" style="font-family: \'product-widget-iconfont\'"></i>';
    for (s = s; s <= 5; s++) r += '<i class="ruk-icon-empty-star-01" style="font-family: \'product-widget-iconfont\'"></i>';
    return 1 == n && (r += "<br />"), r += '<span class="count">(' + t + i + ")</span>"
}
ratingSnippet = function(e, t) {
    void 0 == t && (t = {}), void 0 == t.linebreak && (t.linebreak = !1), void 0 == t.color && (t.color = "#67c116");
    var i = [],
        n = document.querySelectorAll("." + e);
    if (n.length > 0)
        for (var r in n) {
            var o = (l = n.item(r)).getAttribute("data-sku").split(";");
            i = i.concat(o)
        }
    var a;
    (a = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP")).onreadystatechange = function() {
        if (a.readyState == XMLHttpRequest.DONE && 200 == a.status) {
            var i = JSON.parse(a.responseText),
                n = document.querySelectorAll("." + e);
            if (n.length > 0)
                for (var r in n) {
                    var o = n.item(r),
                        d = o.getAttribute("data-sku").split(";"),
                        c = 0,
                        l = 0,
                        u = 0,
                        p = [];
                    for (r in i)
                        for (s in d) "" != d[s] && void 0 != d[s] && void 0 != i[r] && void 0 != i[r].sku && d[s].toString().trim() == i[r].sku.toString().trim() && -1 == p.indexOf(i[r].sku) && (c += parseFloat(i[r].average_rating) * i[r].num_ratings, u += parseFloat(i[r].num_ratings), l++, p.push(i[r].sku));
                    if (c /= u, l > 0) {
                        var v = void 0 != t.text ? " " + t.text : "";
                        o.innerHTML = renderSnippet(c, u, v, t.linebreak)
                    }
                    t.callback && t.callback({
                        rating: c,
                        count: l
                    })
                }
        }
    };
    var d = "sku=" + encodeURIComponent(i.join(";")) + "&store=" + t.store;
    d.length > 2e3 ? (a.open("POST", "https://api-cache.reviews.co.uk/product/rating-batch", !0), a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.send(d)) : (a.open("GET", "https://api-cache.reviews.co.uk/product/rating-batch?" + d, !0), a.send());
    var c = document.createElement("div");
    if (c.innerHTML = '<div id="reviews_fade" style="display:none;z-index:4000;"><div id="reviews_container"><a class="close">&times;</a><div id="reviews_widget"></div> </div></div>', document.body.appendChild(c), (n = document.querySelectorAll("." + e)).length > 0)
        for (var r in n) {
            var l = n.item(r);
            void 0 != t.color && (l.style.color = t.color), "undefined" != typeof productWidget && (l.onclick = function(e) {
              /*
                var i = this.getAttribute("data-sku");
                document.getElementById("reviews_widget").innerHTML = "";
                var n = {
                    store: t.store,
                    sku: i,
                    css: t.css,
                    primaryClr: t.color,
                    neutralClr: "#EBEBEB",
                    buttonClr: "#EEE",
                    textClr: "#333",
                    tabClr: "#eee",
                    questions: !0,
                    showTabs: !1,
                    ratingStars: !1,
                    showAvatars: !0
                };
                void 0 != t.writeButton && (n.writeButton = t.writeButton), productWidget("reviews_widget", n), document.getElementById("reviews_fade").style.display = "block", document.body.style.overflow = "hidden"
                */
              $('html, body').animate({ scrollTop: $('.p-accordian__main').offset().top - ($('.m-header').height())}, 1000);
            })
        }
    document.getElementById("reviews_fade").onclick = function() {
        document.getElementById("reviews_fade").style.display = "none", document.body.style.overflow = "auto"
    }
}, "function" == typeof ratingSnippetCallback && ratingSnippetCallback();